import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { images } from "../../config/images";
import { getSFGBoxNo, getSFGBoxStorageData, submitRackId } from "./services";
import dayjs from "dayjs";
import { toast, ToastContainer } from "react-toastify";

// Styled paper component for the card-like containers.
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  gap: "8px",
}));

const SFGBoxStorage = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [boxNo, setBoxNo] = useState();
  const [newBoxNo, setNewBoxNo] = useState(null);
  const [sfgBoxData, setSFGBoxData] = useState({});
  const [rackId, setRackId] = useState("");
  const popupRef = useRef(null);

  console.log("newBoxNonewBoxNonewBoxNo", newBoxNo);

  useEffect(() => {
    if (newBoxNo !== null) {
      dispatchOrderDetailAPI();
    }
  }, [newBoxNo]);

  const uidType1 = boxNo;
  console.log("uidType1uidType1", uidType1);
  const uidValidation = uidType1
    ? uidType1.split("/").pop() == "raychem."
      ? ""
      : uidType1.split("/").pop()
    : "";

  const scanUidType = uidValidation.length <= 13 ? uidValidation : "";
  useEffect(() => {
    if (scanUidType.length == 13) {
      setNewBoxNo(newBoxNo + 1);
    }
  }, [scanUidType]);
  const handleClick = () => {
    setShowPhone(true);
  };

  const handleSubmitData = async () => {
    if(!sfgBoxData?.box_no){
      toast.error("Please scan the QR");
      return;
    }
    if (!rackId) {
      toast.error("Please enter rack id");
      return;
    }
 
    const params = {
      rack_id: rackId,
      sfg_box_no: sfgBoxData?.box_no,
    };
    try {
      const resp = await submitRackId(params);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setTimeout(() => navigate("/SFG-store"), 500);
      }
    } catch (e) {
      if (e.response.status == 400) {
        toast.error(e.response.data.message);
      }
    }
  };

  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setShowPhone(false);
    }
  };

  useEffect(() => {
    // Attach the click event listener when the popup is ope
    if (showPhone) {
      window.addEventListener("click", handleOutsideClick);
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [showPhone]);
  const dispatchOrderDetailAPI = async () => {
    try {
      const response = await getSFGBoxStorageData(uidType1);
      if (response.status === 200) {
        setSFGBoxData(response.data.payload);
        toast.success(response.data.message);
        setBoxNo("");
        setShowPhone(false);
      }
    } catch (e) {
      setBoxNo("");
      if (e.response.status == 400) {
        toast.error(e.response.data.message);
        setShowPhone(false);
      }
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    handleBoxNumber();
  }, []);
  const handleBoxNumber = async () => {
    try {
      const resp = await getSFGBoxNo();
      if (resp.status == 200 || resp.status == 201) {
        setBoxNo("");
      }
    } catch (error) {
      setBoxNo();
    }
  };
  const handleBoxNo = (e) => {
    const boxNoData = e.target.value;
    setBoxNo(boxNoData);
  };
  return (
    <>
      <ToastContainer />
      {showPhone ? (
        <div>
          <input
            type="text"
            placeholder="Enter value"
            value={boxNo}
            onChange={handleBoxNo}
            className="input-box"
            style={{ paddingLeft: "20px", position: "absolute", top: "10px" }}
            autoFocus
          />
        </div>
      ) : null}
      <div className="dashboard-wrapper page-wraper">
        <div className="page-header">
          <div
            className="page-back-btn"
            onClick={() => navigate("/SFG-store")}
            style={{ cursor: "pointer" }}
          >
            <ArrowBackIcon />
            <span>SFG Box Storage</span>
          </div>
        </div>
        <Grid container spacing={2}>
          {/* Left column for SFG Box Storage */}
          <Grid item xs={12} md={6}>
            <StyledPaper>
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#1a237e" }}
              >
                SFG Box Storage
              </Typography>
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: 2,
                }}
              >
                <div onClick={handleClick} style={{ cursor: "pointer" }}>
                  <img src={images.DemoOR} alt="Scan QR Code" />
                  <Typography variant="body1" sx={{ mt: 5, color: "#555" }}>
                    Please Scan QR on SFG box Label!
                  </Typography>
                </div>
                {showPhone && (
                  <div className="Phone-image" ref={popupRef}>
                    <img
                      src={require("../../assets/images/phone.png")}
                      alt="Phone"
                      className="Phone-img"
                    />
                  </div>
                )}
              </Box>
            </StyledPaper>
          </Grid>

          {/* Right column for SFG Box Details */}
          <Grid item xs={12} md={6}>
            <StyledPaper>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "#1a237e",
                  textAlign: "left",
                  mb: 1,
                }}
              >
                SFG Box Details
              </Typography>
              <Box
                component="form"
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  fontSize: "15px",
                }}
                noValidate
                autoComplete="off"
              >
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Gloves Class</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.class_name}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Gloves Size</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.size_name}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Gloves Type</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.gloves_type}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Lot No</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.lot_no}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Cuff</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.cuff}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Length</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.length}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Quantity</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.quantity}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Date & Time</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={
                        sfgBoxData?.created_at
                          ? dayjs(sfgBoxData?.created_at).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : ""
                      }
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Box No.</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      value={sfgBoxData?.sfg_label}
                      variant="outlined"
                      className="form-input-data"
                      required
                      disabled
                    />
                  </FormControl>
                </div>
                <div
                  className="gloves-form"
                  style={{ textAlign: "left", width: "63%" }}
                >
                  <label className="input-label">Rack ID</label>
                  <FormControl fullWidth className="select-input">
                    <input
                      id="outlined-basic"
                      variant="outlined"
                      value={rackId}
                      onChange={(e) => setRackId(e.target.value)}
                      className="form-input-data"
                      required
                    />
                  </FormControl>
                </div>

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#1a237e",
                      "&:hover": { backgroundColor: "#3f51b5" },
                      textTransform: "capitalize",
                    }}
                    onClick={handleSubmitData}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            </StyledPaper>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default SFGBoxStorage;